// extracted by mini-css-extract-plugin
module.exports = {"container":"changepw_container__3PgkU","space-y-6":"changepw_space-y-6__2rDhk","submitBtn":"changepw_submitBtn__2iyto"};